import { render, staticRenderFns } from "./PaasSimuladorDisplay.vue?vue&type=template&id=6d1ed642&scoped=true&"
import script from "./PaasSimuladorDisplay.vue?vue&type=script&lang=js&"
export * from "./PaasSimuladorDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PaasSimuladorDisplay.vue?vue&type=style&index=0&id=6d1ed642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ed642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VExpandTransition,VIcon,VImg,VRow,VTextField})
